var _path, _path2, _path3, _line, _line2, _line3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 55,
    viewBox: "0 0 41 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0268 18.863L18.4668 14.493L20.7068 11.743H19.7768L16.4568 15.833V11.743H15.6968V18.863H16.4568V16.873L17.9568 15.073L20.1268 18.863H21.0268Z",
    fill: "#FFD4A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3507 14.343C25.0007 13.993 24.6407 13.883 24.1707 13.883C23.6007 13.883 23.0607 14.133 22.7907 14.543V13.943H22.0707V18.863H22.7907V15.843C22.7907 15.093 23.2507 14.523 23.9707 14.523C24.3507 14.523 24.5507 14.613 24.8207 14.883L25.3507 14.343Z",
    fill: "#FFD4A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6296 24.2192C24.6002 24.2192 28.6296 20.1898 28.6296 15.2192C28.6296 10.2487 24.6002 6.21924 19.6296 6.21924C14.6591 6.21924 10.6296 10.2487 10.6296 15.2192C10.6296 20.1898 14.6591 24.2192 19.6296 24.2192Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.30566,
    y1: 31.5925,
    x2: 35.6946,
    y2: 31.5925,
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.30566,
    y1: 38.1677,
    x2: 35.6946,
    y2: 38.1677,
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.30566,
    y1: 43.9211,
    x2: 19.7501,
    y2: 43.9211,
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 39.5,
    height: 53.5,
    rx: 4.25,
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOffer);
export default __webpack_public_path__ + "static/media/ico_offer.92860ea4aac98826bf0c770088c13fd7.svg";
export { ForwardRef as ReactComponent };